/**
 * Display names for the wire-format enum values ("NineVNine" → "9v9"). The wire format is the
 * C# enum name and never changes; every user-facing surface renders through this map.
 */
export const FORMAT_LABEL: Record<string, string> = {
  ThreeVThree: '3v3',
  FiveVFive: '5v5',
  SevenVSeven: '7v7',
  NineVNine: '9v9',
  ElevenVEleven: '11v11',
};

export function fmtFormat(format: string): string {
  return FORMAT_LABEL[format] ?? format;
}
